
/*
|--------------------------------------------------------------------------
| Custom Javascript code
|--------------------------------------------------------------------------
|
| Now that you configured your website, you can write additional Javascript
| code inside the following function. You might want to add more plugins and
| initialize them in this file.
|
*/

$(function() {

	$('#feedback a').click(function(e){
        e.preventDefault();
		location.replace('http://www.google.com');
	});

	$('.nav-link').click(function(){
		var url = $(this).attr("data-value");
        location.replace(url);
	});

    $('.navbar-brand').click(function(){
        var url = $(this).attr("data-value");
        location.replace(url);
    });

    $('.news-click').click(function(){
        var url = $(this).attr("data-value");
        location.replace(url);
    });

    $('.badge-pill').click(function(){
        var url = $(this).attr("data-value");
        location.replace(url);
    });


    var showed = localStorage.getItem("show-pop-up");
    if(!showed)
	{
        $("#esc-exit-popup").addClass("show");
        localStorage.setItem("show-pop-up", 1);
	}

	function doClose(e)
	{
		// console.log(123);
		if (!e) e = window.event;

		if (e.keyCode)
		{
			if (e.keyCode == "27")
            {
                window.close();
                $('body').hide();
                location.replace("https://www.google.com.au");
            }

		}
		else if (e.charCode)
		{
			if (e.charCode == "27")
            {
                window.close();
                $('body').hide();
                location.replace("https://www.google.com.au");
            }
		}
	}

	$(document).keydown(doClose);

	// window.location.reload();
	$('.redirect-to-page').click(function(){
		var url = $(this).attr("data-value");

		if(url === "https://google.com"){
            location.replace(url);
		}else{
            window.open(url, "_self");
		}

	});


});
